export default "__VITE_ASSET__20ef4697__"